import { useRouteLoaderData } from 'react-router'

import { AppLoaderData } from '~/portal/types/app.ts'
import { FeatureFlags } from '~/portal/types/flags.ts'

export const useFeatureFlag = (flag: FeatureFlags): any => {
  const { flags } = useRouteLoaderData<AppLoaderData>('root') as AppLoaderData ?? { flags: {} }
  return flags?.[flag] ?? false
}